import { useContext, useEffect } from 'react';
import { ReactReduxContext } from 'react-redux';
import { clearAutoFocusRow } from '../store/actions/task';
import { autoFocusRowSelector } from '../store/selectors/task';

// Scroll the form viewport (#app-main) to vertically center the element.
const scrollAppMainTo = (element) => {
  const appMain = document.getElementById('app-main');
  if (!appMain) {
    return;
  }
  const elementRect = element.getBoundingClientRect();
  const containerRect = appMain.getBoundingClientRect();
  const top = appMain.scrollTop
    + (elementRect.top - containerRect.top)
    - (appMain.clientHeight - elementRect.height) / 2;
  appMain.scrollTo({ top, behavior: 'smooth' });
};

// Focus the element on mount when isFocusOnInit is set. If the focus comes from a
// block the user just added (autoFocusRow set in redux), scrolls the focused element
// into view and clear the flag so a later remount cannot re-steal the focus.
// The Redux store is read through context so there is no error when used outside a
// Provider (in isolated unit tests for example).
const useFocusOnInit = (ref, isFocusOnInit, afterFocus) => {
  const reduxContext = useContext(ReactReduxContext);

  useEffect(() => {
    if (!isFocusOnInit) {
      return;
    }
    ref?.current?.focus();
    if (afterFocus) {
      afterFocus();
    }
    if (!reduxContext) {
      return;
    }
    const { store } = reduxContext;
    if (autoFocusRowSelector(store.getState())) {
      const focused = document.activeElement;
      if (focused && focused !== document.body) {
        scrollAppMainTo(focused);
      }
      store.dispatch(clearAutoFocusRow());
    }
  }, []);
};

export default useFocusOnInit;
